import { EFileStatusAction } from "./efile-status-action.model";
import { IEFileDisplayStatus, IEFileStatus } from "./efile-status.interface";

export class EFileSubmissionStatus implements IEFileStatus{
    static readonly VirusFound = new EFileSubmissionStatus("virus-found", 2);
    static readonly NotStarted = new EFileSubmissionStatus("not-started", 50);
    static readonly SignatureRequired = new EFileSubmissionStatus("signature-required", 60);
    static readonly ActionRequired = new EFileSubmissionStatus("action-required", 70);
    static readonly Processing = new EFileSubmissionStatus("processing", 80);
    static readonly NotSubmitted = new EFileSubmissionStatus("not-submitted", 100);
    static readonly Pending = new EFileSubmissionStatus("pending", 200);
    static readonly TechnicalError = new EFileSubmissionStatus("technical-error", 300);
    static readonly ContentError = new EFileSubmissionStatus("content-error", 400);
    static readonly ContentErrorActionRequired = new EFileSubmissionStatus("content-error-action-required", 450);
    static readonly SuccessfullySubmitted = new EFileSubmissionStatus("successfully-submitted", 500);
    static readonly SubmittedWithwarnings = new EFileSubmissionStatus("submitted-with-warnings", 600);

    private constructor(public readonly status: string, public readonly index: number) {
    }
}

export class EFileSubmissionDisplayStatus implements IEFileDisplayStatus {

    static readonly VirusFound = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.VirusFound], "Virus found", "danger");
    static readonly NotStarted = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.NotStarted], "-", "secondary");
    static readonly SignatureRequired = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.SignatureRequired], "Signature required", "warning", EFileStatusAction.ReUpload);
    static readonly ActionRequired = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.ActionRequired, EFileSubmissionStatus.ContentErrorActionRequired], "Action required", "warning-secondary", EFileStatusAction.Edit);
    static readonly Processing = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.Processing], "Processing", "info");
    static readonly NotSubmitted = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.NotSubmitted], "Not submitted", "secondary");
    static readonly Pending = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.Pending], "Pending", "info");
    static readonly TechnicalError = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.TechnicalError], "Technical error", "danger", EFileStatusAction.ReUpload);
    static readonly ContentError = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.ContentError], "Content error", "danger", EFileStatusAction.ReUpload);
    static readonly SuccessfullySubmitted = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.SuccessfullySubmitted], "Successfully submitted", "success");
    static readonly SubmittedWithwarnings = new EFileSubmissionDisplayStatus([EFileSubmissionStatus.SubmittedWithwarnings], "Submitted with warnings", "success");

    private constructor(public readonly statusses: EFileSubmissionStatus[], public readonly name: string, public readonly indicator: string, public readonly action: EFileStatusAction = null) {

    }

    static readonly all = [
        EFileSubmissionDisplayStatus.VirusFound, 
        EFileSubmissionDisplayStatus.NotSubmitted, 
        EFileSubmissionDisplayStatus.SignatureRequired, 
        EFileSubmissionDisplayStatus.ActionRequired, 
        EFileSubmissionDisplayStatus.Processing, 
        EFileSubmissionDisplayStatus.Pending, 
        EFileSubmissionDisplayStatus.NotStarted, 
        EFileSubmissionDisplayStatus.TechnicalError, 
        EFileSubmissionDisplayStatus.ContentError,
        EFileSubmissionDisplayStatus.SuccessfullySubmitted, 
        EFileSubmissionDisplayStatus.SubmittedWithwarnings 
    ];

    static parse(status: string) : EFileSubmissionDisplayStatus{
        return EFileSubmissionDisplayStatus.all.find(x => x.statusses.some(s => s.status == status));
    }

    static parseAll(statusses: string[]) : EFileSubmissionDisplayStatus[] {
        return EFileSubmissionDisplayStatus.all.filter(x => x.statusses.some(s => statusses.some(status => s.status === status)));
    }
}